<div class="audit-history-container">
  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <!-- No data template -->
  <ng-template #noData>
    <div class="d-flex flex-column justify-content-center align-items-center p-4 bg-light border rounded shadow-sm">
      <svg xmlns="http://www.w3.org/2000/svg" 
           width="120" height="120" 
           viewBox="0 0 24 24" 
           fill="none" stroke="#2563eb" 
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
           style="opacity: 0.9;" class="mb-3">
        <rect x="3" y="4" width="18" height="16" rx="2" ry="2"></rect>
        <line x1="8" y1="10" x2="16" y2="10"></line>
        <line x1="8" y1="14" x2="14" y2="14"></line>
      </svg>
      <h5 class="text-primary">No Audit History Found</h5>
      <p class="text-secondary small">No audit records available for this selection.</p>
    </div>
  </ng-template>

  <!-- Grid container -->
  <div class="table-container scrollbar" *ngIf="gridData?.length && gridData.length > 0 && !isLoading; else noData">
    <ag-grid-angular 
      class="ag-theme-quartz auto-height commontable"
      [rowData]="gridData"
      [columnDefs]="displayedColumnDefs"
      [defaultColDef]="defaultColDef"
      [suppressRowClickSelection]="false"
      [pagination]="false"
      [paginationPageSize]="paginationPageSize"
      [class]="themeClass"
      (gridReady)="onGridReady($event)"
      [gridOptions]="gridOptions">
    </ag-grid-angular>

    <!-- Pagination Controls -->
    <div class="d-flex justify-content-end align-items-center mt-3">
      <ul class="pagination mb-0">
        <!-- First Page -->
        <li class="page-item" [class.disabled]="currentPage === 1">
          <button class="page-link" (click)="goToFirstPage()" [disabled]="currentPage === 1">First</button>
        </li>

        <!-- Previous Page -->
        <li class="page-item" [class.disabled]="currentPage === 1">
          <button class="page-link" (click)="goToPreviousPage()" [disabled]="currentPage === 1">Previous</button>
        </li>

        <!-- Current Page Info -->
        <li class="page-item disabled">
          <span class="page-link">Page {{ currentPage }} of {{ totalPages }}</span>
        </li>

        <!-- Page Size Dropdown -->
        <li class="ms-2">
          <select
            id="pageSizeSelector"
            class="form-select form-select-sm page-link"
            [(ngModel)]="paginationPageSize"
            (change)="onPageSizeChange()"
            style="width: auto;"
          >
            <option *ngFor="let size of paginationPageSizeSelector" [value]="size">{{ size }}</option>
          </select>
        </li>

        <!-- Next Page -->
        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <button class="page-link" (click)="goToNextPage()" [disabled]="currentPage === totalPages">Next</button>
        </li>

        <!-- Last Page -->
        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <button class="page-link" (click)="goToLastPage()" [disabled]="currentPage === totalPages">Last</button>
        </li>
      </ul>
    </div>

    <!-- Total items info -->
    <div class="d-flex justify-content-end mt-2">
      <span class="text-muted small">Total Records: {{ totalItems }}</span>
    </div>
  </div>
</div>
